import {Component, OnInit} from '@angular/core';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {getAppThemeName, getCookie} from 'src/app/core/functions/common.function';
import {NoticeInfo} from 'src/app/core/interfaces/common';
import {environment} from 'src/environments/environment.generated';
import {CommonService} from '../../services/common.service';
import {PrivacyModalComponent} from "../privacy-modal/privacy-modal.component";
import {DBModalModule, DBModalService} from "@db/db-core";
import {CookieNoticeModal} from "../cookie-notice/cookie-notice.modal";
import {DBFooterComponent} from "@db/db-components";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    DBFooterComponent,
    DBModalModule,
    TranslateModule
  ]
})
export class FooterComponent implements OnInit {
  public getThemeName?: string;
  public noticeAcceptance: NoticeInfo = {cookieAccepted: false};

  constructor(
    private translate: TranslateService,
    private appService: CommonService,
    private readonly modalService: DBModalService
  ) {
  }

  ngOnInit(): void {
    this.getThemeName = getAppThemeName();
    this.appService._languageData.subscribe(data => {
      this.translate.use(data.activeLang);
    });
    this.checkNoticeAcceptance();
  }

  ngAfterViewInit() {
    if (getAppThemeName() === "db") {
      document.addEventListener('click', (e: Event) => {
        const a = (e.target as HTMLElement).closest('a');
        if (a?.getAttribute('href') === 'https://www.deutsche-bank.de/pk/lp/datenschutz.html') {
          e.preventDefault();
          this.openPopup();
        }
      });
    }
    if (getAppThemeName() === "nb") {
      document.addEventListener('click', (e: Event) => {
        const a = (e.target as HTMLElement).closest('a');
        if (a?.getAttribute('href') === 'https://www.norisbank.de/service/kontakt-und-wissen/rechtliches.html') {
          e.preventDefault();
          this.openPopup();
        }
      });
    }
  }

  openPopup() {
    window.scrollTo(0, 0);
    this.modalService.openWithComponent(PrivacyModalComponent, {closeOnBackdropClickOrEscKey: false});
  }

  setFooterLinks(linkNo: number) {
    if (environment.brand === 'pb') {
      return this.translate.instant("FOOTER.additional_area.links_url_pb.link_" + linkNo)
    } else {
      return this.translate.instant("FOOTER.additional_area.links_url.link_" + linkNo)
    }
  }

  checkNoticeAcceptance() {
    const cookieAccepted = getCookie('COOKIE_ACCEPTED');
    if (cookieAccepted && (cookieAccepted === '1001' || cookieAccepted === '1002')) {
      this.noticeAcceptance = ({...this.noticeAcceptance, cookieAccepted: true});
      this.appService.changeNoticeAcceptanceStatus(this.noticeAcceptance);
    } else {
      this.appService._noticeAcceptance.subscribe((data: NoticeInfo) => {
        this.noticeAcceptance = data;
      });
      window.scrollTo(0, 0);
      this.modalService.openWithComponent(CookieNoticeModal, {closeOnBackdropClickOrEscKey: false});
    }
  }

  protected readonly getAppThemeName = getAppThemeName;
}
